import { Component, Inject, Input, OnInit } from '@angular/core';
import { DependantDto } from '../../../../../service/dto';
import { ProductDto, ProductExtendedDto } from '../../../../../service/dto-insurance';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

export class Result {
	fromDate?: Date;
	extended?: ProductExtendedDto;
}
@Component({
	selector: 'app-policy-extended-cover-modal',
	standalone: false,
	templateUrl: './policy-extended-cover-modal.component.html',
	styleUrl: './policy-extended-cover-modal.component.scss'
})
export class PolicyExtendedCoverModalComponent implements OnInit {
	@Input() dependant!: DependantDto;
	@Input() current?: ProductExtendedDto;
	@Input() fromDate?: Date;
	@Input() product!: ProductDto;
	form!: FormGroup;

	constructor(private modalRef: NzModalRef, private fb: FormBuilder) {
	}

	ngOnInit() {
		this.form = this.fb.group({
			fromDate: [this.fromDate, Validators.required]
		});
	}

	isExtensionValid(ext: ProductExtendedDto): boolean {
		// TODO: plug in your rule engine
		// Example: relationship + age check
		return true;
	}

	selected(input: ProductExtendedDto) {
		this.modalRef.close({ fromDate: this.form.get('fromDate')!.value, extended: input });
	}

	remove() {
		this.modalRef.close({ fromDate: undefined, extended: undefined });
	}
	cancel() {
		this.modalRef.close({ fromDate: this.fromDate, extended: this.current });
	}
}
